<div class="cooperate-information">
    <div class="information-item">
        <span class="label pr-4">{{"COMPANY_NAME" | translate}}</span>
        <span class="value">{{"COMPANY_NAME_DETAIL" | translate}}</span>
    </div>
    <div class="information-item">
        <span class="label pr-4">{{"COMPANY_TYPE" | translate}}</span>
        <span class="value">{{"COMPANY_TYPE_DETAIL" | translate}}</span>
    </div>
    <div class="information-item">
        <span class="label pr-4">{{"COMPANY_ESTABLISHMENT_DATE" | translate}}</span>
        <span class="value">{{"COMPANY_ESTABLISHMENT_DATE_DETAIL" | translate}}</span>
    </div>
    <div class="information-item">
        <span class="label pr-4">{{"COMPANY_BUSSINEE_PERIOD" | translate}}</span>
        <span class="value">{{"COMPANY_BUSSINEE_PERIOD_DETAIL" | translate}}</span>
    </div>
    <div class="information-item">
        <span class="label pr-4">{{"COMPANY_BUSSINESS_PLACE" | translate}}</span>
        <span class="value">{{"COMPANY_BUSSINESS_PLACE_DETAIL" | translate}}</span>
    </div>
</div>





